<template>
  <div class="row">
    <div class="col-12 mb-3">
      <router-view name="filter"></router-view>
      <router-view name="map"></router-view>
      <router-view name="table"></router-view>
      <router-view name="form"></router-view>

      <router-view name="preliminary_risk_analyses_index"></router-view>
      <router-view name="risk_analyses_index"></router-view>
      <router-view name="risk_analyses_multiple"></router-view>
      <router-view name="risk_analyses_create_index"></router-view>
      
      <router-view name="action_plan_index"></router-view>
      <router-view name="action_plan_form"></router-view>
    </div>
  </div>
</template>

<script>
  export default {}
</script>
